import React from 'react'
import { object, func } from 'prop-types'

import retrieveAndProcessDataForPage from '@/lib/data-for-page-processor-and-retriever'
import createRenderProductQuery from '@/query/product/render-product'
import StandardMeta from '@/component/Meta/Standard'

import Layout from '@/component/Structure/Layout'

const ProductPage = ({ product, section, pageData, __url }) => {
  const layout = section?.layouts?.product?.layout
  const subNavItems = [
    { name: 'Program Overview', key: 'overview' },
    { name: 'Our Research', key: 'research' },
    { name: 'How Pricing Works', key: 'pricing' },
    { name: 'Technical Specifications', key: 'technical' }
  ].filter(({ key }) => product[key]?.widgets?.length > 0)
  const { params } = pageData
  const activeTab = params.tab || subNavItems[0]?.key

  return (
    <>
      <StandardMeta
        title={product.name}
        seoTitle={product.metaTitle || product.name}
        description={product.metaDescription || product.tagLine}
        canonicalUrl={pageData.url}
        images={
          product.images.hero_16x9_1920
            ? [
                {
                  url: product.images.hero_16x9_1920[0]?.url,
                  width: 1920,
                  height: 1080,
                  alt: product.name
                }
              ]
            : null
        }
      />
      <Layout
        layout={layout}
        __url={__url}
        section={section}
        pageData={{ ...pageData, activeTab }}
      />
    </>
  )
}

ProductPage.propTypes = {
  product: object,
  section: object,
  pageData: object,
  __url: func.isRequired
}

ProductPage.getInitialProps = async (context) => {
  const params = context?.query
  const query = createRenderProductQuery()
  const data = await retrieveAndProcessDataForPage(context, query)
  if (data.error) return data
  const product = data?.response?.resource
  const section = product?.entitySection
  const url = data?.vars?.url
  const pageData = { url, params, product, section }
  return { ...data.response, product, section, pageData }
}

export default ProductPage
